import { render, staticRenderFns } from "./PublicCustomerMessages.vue?vue&type=template&id=e0521e46&"
import script from "./PublicCustomerMessages.vue?vue&type=script&lang=js&"
export * from "./PublicCustomerMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports